import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';
import { Accordion } from '~/shared/ui/Accordion/Accordion';
import { Divider } from '~/shared/ui/Divider/Divider';

export const SteamCardButton = css`
  aspect-ratio: unset;
`;

export const SteamCardImage = css`
  width: 100%;
  height: 100%;
  aspect-ratio: 390 / 128;
  object-fit: cover;
  display: block;
  overflow: hidden;
  border-radius: 12px;
`;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SingleCardWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 4px;
  aspect-ratio: 390 / 128;
`;

export const Fieldset = styled.fieldset`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const BottomContent = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  margin: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: rgba(0, 0, 0, 0.8);
  box-shadow:
    0 -20px 30px rgba(0, 0, 0, 0.9),
    0 -10px 20px rgba(0, 0, 0, 0.6),
    0 -5px 10px rgba(0, 0, 0, 0.5),
    0 20px 30px rgba(0, 0, 0, 0.9),
    0 10px 20px rgba(0, 0, 0, 0.6),
    0 5px 10px rgba(0, 0, 0, 0.5);
`;

export const ButtonLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const inputClassName = css`
  background: ${uiToken.color.background.secondary};
`;

export const DividerStyled = styled(Divider)`
  margin: 12px;
`;

export const Content = styled.div`
  padding: 16px;
  padding-bottom: 140px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const StyledAccordion = styled(Accordion)`
  margin-top: 16px;
`;
